import { InsuranceMonitorConfiguration } from "@wingspanhq/wingspan-api-sdk";
import intersection from "lodash/intersection";

import { selectorPolicyTypesFromSettings } from "./selectorPolicyTypesFromSettings";

export const selectorIsPolicyTypesMatched = ({
  insuranceMonitorConfiguration,
  // wire values — the configuration's policy types are compared as-is
  policyTypes
}: {
  insuranceMonitorConfiguration?: InsuranceMonitorConfiguration;
  policyTypes?: string[];
}) => {
  const configurationTypes = selectorPolicyTypesFromSettings(
    insuranceMonitorConfiguration
  );

  return intersection(configurationTypes, policyTypes).length > 0;
};
